export enum Anchor {
    TOP="top",
    BOTTOM="bottom",
    LEFT="left",
    RIGHT="right",
    ANY="any",
};